/** «Выписки → Покрытие»: ответ ручки `/api/statement-coverage`. */
import { apiFetch } from "@/lib/api";

export type CoverageAccount = {
  key: string;
  /** `null` — счёт известен только из пустой выписки (операций нет). */
  account_id: number | null;
  number: string | null;
  /** Продукт Т-Банка, когда номера нет. */
  product: string | null;
  bank_name: string | null;
  statements: number;
  /** ISO с `Z`; `null` — выписки по счёту нет. */
  uploaded_at: string | null;
  /** До какой даты доходит выписка, `YYYY-MM-DD`. */
  covered_to: string | null;
  last_operation: string | null;
  last_statement_id: number | null;
};

export type CoverageSlot = "sber" | "tbank" | "vtb" | "modul" | "ozon" | "other";

export type CoveragePerson = {
  id: number;
  name: string;
  blocks: {
    kind: "business" | "personal";
    cells: { slot: CoverageSlot; accounts: CoverageAccount[] }[];
  }[];
};

export const SLOT_LABEL: Record<CoverageSlot, string> = {
  sber: "Сбербанк",
  tbank: "Т-Банк",
  vtb: "ВТБ",
  modul: "Модульбанк",
  ozon: "Озон",
  other: "другие",
};

export const KIND_LABEL = { business: "ИП", personal: "Физлицо" } as const;

export async function loadCoverage(): Promise<CoveragePerson[]> {
  return (await apiFetch<{ people: CoveragePerson[] }>("/api/statement-coverage")).people;
}
